import { GA_EDIT_EMAIL_MISMATCH } from '../constants/analytics';
import { trackGeneralAuthAction } from './general';
import { IAnalyticsDimensionsProps } from './interfaces';

export const trackEditEmailMismatch = ({
    analytics,
}: {
    analytics: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({ analytics, action: GA_EDIT_EMAIL_MISMATCH });
};
